// import { defineBoot } from '#q-app/wrappers';
import axios, { type AxiosError, type AxiosInstance } from 'axios';

import { DEV_API, LOCAL_API, PROD_API } from 'src/config/api';
import getToken from 'src/helpers/editor/getToken';

declare module 'vue' {
  interface ComponentCustomProperties {
    $axios: AxiosInstance;
    $api: AxiosInstance;
  }
}

function getApiBaseUrl(): string {
  if (process.env.ENV_NAME === 'local') return LOCAL_API;

  if (process.env.ENV_NAME === 'dev') return DEV_API;

  return PROD_API;
}

/**
 * Utilizar esta variável nos outros arquivos pois o process.env
 * é acessível apenas em arquivos boot
 */
export const apiBaseUrl = getApiBaseUrl();

// Be careful when using SSR for cross-request state pollution
// due to creating a Singleton instance here;
// If any client changes this (global) instance, it might be a
// good idea to move this instance creation inside of the
// "export default () => {}" function below (which runs individually
// for each client)
const api = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    common: {
      Authorization: `Bearer ${getToken()}`,
    },
    'Cache-Control': 'no-cache',
  },
});

// Ref: https://axios-http.com/docs/interceptors
api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.code === 'ERR_NETWORK') {
      console.warn('A API está fora do ar');
    }

    if (error.response) {
      const { status, data } = error.response as {
        status: number;
        data: Record<string, any>;
      };

      const isLoginUrl = window.location.pathname === '/login';
      const errorMessage = data.roleUpdated
        ? 'Seu nível de permissão mudou, realize o login novamente.'
        : 'Seu acesso expirou, realize o login novamente.';

      if (!isLoginUrl && (status === 401 || status === 403)) {
        // eslint-disable-next-line no-alert
        alert(errorMessage);
        localStorage.removeItem('editor-token');
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  },
);

// export default defineBoot(({ app }) => {
//   // for use inside Vue files (Options API) through this.$axios and this.$api

//   app.config.globalProperties.$axios = axios;
//   // ^ ^ ^ this will allow you to use this.$axios (for Vue Options API form)
//   //       so you won't necessarily have to import axios in each vue file

//   app.config.globalProperties.$api = api;
//   // ^ ^ ^ this will allow you to use this.$api (for Vue Options API form)
//   //       so you can easily perform requests against your app's API
// });

export { api };
